export default "__VITE_ASSET__nQxQ8pDk__"